import React, { useState, useEffect } from "react";
import CustomDropdown from "../CustomDropdown/CustomDropdown";
import styles from "./SubMapping.module.css";
import { getSaleSubmappingCurrency } from "../../../../Bookclosure/Services/ApiHandler";

export default function Currency({ SaleID, onMappingChange }) {
  const [columnOptions, setColumnOptions] = useState([]);
  const [currencyFields, setCurrencyFields] = useState([]);
  const [selectedValues, setSelectedValues] = useState({});

  const handleFieldChange = (fieldId, value) => {
    setSelectedValues((prev) => {
      const updated = { ...prev, [fieldId]: value };
      onMappingChange(updated);
      return updated;
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getSaleSubmappingCurrency(SaleID);
        const { fields, labelList } = res.data;

       const transformedFields = (fields || []).map((currency) => ({
        id: currency.toLowerCase(),
        label: currency,
        type: "dropdown",
      }));

        setColumnOptions(labelList || []);
        setCurrencyFields(transformedFields);

        const initialState = {};
        transformedFields.forEach((f) => {
          initialState[f.id] = "";
        });

        setSelectedValues(initialState);
        onMappingChange(initialState);

      } catch (err) {
        console.error("GET Sale Currency error:", err);
      }
    };

    fetchData();
  }, [SaleID]);

  return (
    <div className={styles.formGroup}>
      {currencyFields.map((field) => (
        <CustomDropdown
          key={field.id}
          label={field.label}
          value={selectedValues[field.id] || ""}
          onChange={(value) => handleFieldChange(field.id, value)}
          options={columnOptions}
          placeholder="Map Column"
        />
      ))}
    </div>
  );
}